import { render } from "./BaseBadge.vue?vue&type=template&id=eb8acac0&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=eb8acac0&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb8acac0"]])

export default __exports__